export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s が選択されていません';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s は空白にすることはできません';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s は必須フィールドです';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s が正しく記入されていません';
                break;

            case 'opt-in':
                translation = '続行するにはチェックボックスをオンにしてください';
                break;

            default:
                translation = 'このフィールドは正しく入力されていません';
                break;
        }

        return translation;
    }

    /**
     * @link https://developers.google.com/maps/documentation/geocoding/intro?hl=nl#StatusCodes
     */
    addressMap(textType) {
        let translation = '';

        switch (textType) {
            case 'ZERO_RESULTS':
                translation = '結果は見つかりませんでした';
                break;

            case 'address-not-checked':
                translation = '地図をドラッグし、ご自宅屋根に 赤いマークを配置してください';
                break;

            default:
                translation = 'エラーが発生しました';
                break;
        }

        return translation;
    }
}
